{
  "active": "Aktiv",
  "associateToType": "Knytt til kostnadstype",
  "closedEvent": "Lukket event",
  "completed": "Gjennomført",
  "contactRegistererd": "kontakt har registrert egeninnsats på denne eventen.",
  "contactsRegistered": "kontakter har registrert egeninnsats på denne eventen.",
  "copyRegistrationLink": "Kopier registreringslink",
  "couldNotCreateEvent": "Kunne ikke opprette event. Vennligst prøv igjen.",
  "couldNotDeleteEvent": "Kunne ikke slette event. Vennligst prøv igjen.",
  "couldNotEditEvent": "Kunne ikke redigere event. Vennligst prøv igjen.",
  "createEvent": "Opprett event",
  "deleteEventWarning": "Er du helt sikker på at dette eventet skal slettes? All egeninnsats knyttet til dette eventet blir slettet.",
  "editEvent": "Rediger event",
  "errorCode.DatesOutsideOfParent": "Tidsrom for event er utenfor prosjekt/aktivitet sitt tidsrom",
  "errorCode.ExpenseTypesNotPresentInProject": "Kostnadstypene du prøver å føre på finnes ikke på prosjekt/aktivitet",
  "eventDescription": "Eventbeskrivelse",
  "eventName": "Navn på event",
  "eventOverview": "Eventoversikt",
  "eventParticipants": "Eventdeltagere",
  "expectedDuration": "Forventet varighet",
  "getRegistrartionInfo": "Hent registreringsinformasjon",
  "hours": "timer",
  "linkCopied": "Link kopiert!",
  "location": "Sted",
  "minutes": "minutter",
  "newEvent": "Nytt event",
  "noParticipantsRegistered": "Ingen deltagere registrert",
  "numberOfEvents": "Antall eventer",
  "numberOfEventsDistributedOnActivities": "fordelt på {{activityCount}} aktiviteter",
  "printQrCode": "Print QR-kode",
  "qrCodeDescription": "Print QR-koden og ha den tingjengelig for rask registrering av egeninnsats på eventet ditt.",
  "qrCodeFor": "QR-kode for",
  "qrCodeForRegistering": "QR-kode for oppmøteregistrering på",
  "qrCodeSidebarDescription": "Deltagere kan selv registrere egeninnsats via QR-kode på eventet eller fra en lenke du sender til\ndem på på epost.",
  "registrationLink": "Registreringslink",
  "scanQrCode": "Scan QR-koden for å åpne registreringslinken.",
  "selectEvent": "Velg event",
  "selfRegistration": "Egenregistrering",
  "showAllContacts": "Vis alle kontakter med registrert egeninnsats på denne eventen:",
  "upcoming": "Kommende",
  "uploadLogo": "Last opp logo (ikke obligatorisk)",
  "gotoAllEvents": "Gå til alle eventer"
}
